export default __webpack_public_path__ + "static/media/strans.c789024f.png";